/**
 * Multiselect value for "no manager" (NULL). Must match PHP FILTER_EMPTY_VALUE on OperationsManagementSummaryByClubRepository.
 */
export const OPS_MGMT_CLUB_SUMMARY_FILTER_EMPTY = "__OPS_MGMT_CLUB_SUMMARY_EMPTY__";
